import { j as r } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: t = 20,
  height: C = 20,
  viewBox: o = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: t,
    height: C,
    viewBox: o,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M15.0258 13.8473L18.5947 17.4163L17.4162 18.5948L13.8473 15.0258C12.5641 16.0525 10.9367 16.6667 9.16666 16.6667C5.02666 16.6667 1.66666 13.3067 1.66666 9.16667C1.66666 5.02667 5.02666 1.66667 9.16666 1.66667C13.3067 1.66667 16.6667 5.02667 16.6667 9.16667C16.6667 10.9367 16.0525 12.5641 15.0258 13.8473ZM13.3539 13.229C14.3729 12.1788 15 10.7463 15 9.16667C15 5.94375 12.3896 3.33334 9.16666 3.33334C5.94374 3.33334 3.33332 5.94375 3.33332 9.16667C3.33332 12.3896 5.94374 15 9.16666 15C10.7463 15 12.1788 14.3729 13.229 13.3539L13.3539 13.229Z",
        fill: s
      }
    )
  }
);
export {
  l as default
};
